/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AccommodationListings_Listing = {
    listingType?: AccommodationListings_Listing.listingType;
    listingId?: string;
    listingName?: string;
};
export namespace AccommodationListings_Listing {
    export enum listingType {
        CITY = 'city',
        REGION = 'region',
    }
}
